module.exports = __webpack_public_path__ + "img/36_81.0fde9266.png";